import { render } from "./Paging.vue?vue&type=template&id=23e1882a&scoped=true"
import script from "./Paging.vue?vue&type=script&lang=js"
export * from "./Paging.vue?vue&type=script&lang=js"

import "./Paging.vue?vue&type=style&index=0&id=23e1882a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Stage-Leadership_Admin_Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e1882a"]])

export default __exports__